import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Children, cloneElement } from 'react';
import classnames from 'classnames';

var getActiveKey = function getActiveKey(props) {
  var multiple = props.multiple,
      activeKey = props.activeKey,
      defaultActiveKey = props.defaultActiveKey;
  var value;

  if (typeof activeKey !== 'undefined') {
    value = activeKey;
  }

  if (!('activeKey' in props) && typeof defaultActiveKey !== 'undefined') {
    value = defaultActiveKey;
  }

  if (value) {
    return multiple ? [].concat(value) : value;
  }

  return multiple ? [] : undefined;
};

var Collapse = /*#__PURE__*/function (_Component) {
  _inherits(Collapse, _Component);

  var _super = _createSuper(Collapse);

  function Collapse() {
    var _this;

    _classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      activeKey: getActiveKey(_this.props)
    };

    _this.onItemChange = function (onItemChange, key) {
      if (!key) {
        return;
      }

      var activeKey = _this.state.activeKey;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          multiple = _this$props.multiple;
      var isActive;
      var newActiveKey;

      if (multiple) {
        newActiveKey = [];
        activeKey = activeKey || [];

        if (activeKey.indexOf(key) > -1) {
          newActiveKey = activeKey.filter(function (i) {
            return i !== key;
          });
        } else {
          newActiveKey = activeKey.slice(0);
          newActiveKey.push(key);
        }

        isActive = newActiveKey.indexOf(key) > -1;
      } else {
        activeKey = activeKey;
        newActiveKey = activeKey === key ? undefined : key;
        isActive = activeKey === key;
      }

      if (!('activeKey' in _this.props)) {
        _this.setState({
          activeKey: newActiveKey
        });
      }

      typeof onItemChange === 'function' && onItemChange(isActive);
      typeof onChange === 'function' && onChange(newActiveKey);
    };

    _this.renderItems = function () {
      var activeKey = _this.state.activeKey;
      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          animated = _this$props2.animated;
      return Children.map(_this.props.children, function (ele) {
        var _ele$props = ele.props,
            disabled = _ele$props.disabled,
            _onChange = _ele$props.onChange;
        var key = ele.key;
        var isActive = multiple ? (activeKey || []).indexOf(key) > -1 : activeKey === key;
        return /*#__PURE__*/cloneElement(ele, {
          animated: animated,
          isActive: isActive,
          onChange: function onChange() {
            return !disabled && _this.onItemChange(_onChange, key);
          }
        });
      });
    };

    return _this;
  }

  _createClass(Collapse, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          className = _this$props3.className,
          onChange = _this$props3.onChange,
          animated = _this$props3.animated,
          activeKey = _this$props3.activeKey,
          defaultActiveKey = _this$props3.defaultActiveKey,
          rest = _objectWithoutProperties(_this$props3, ["prefixCls", "className", "onChange", "animated", "activeKey", "defaultActiveKey"]);

      var cls = classnames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "--animated"), animated));
      return /*#__PURE__*/React.createElement("div", _extends({
        className: cls
      }, rest), this.renderItems());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var newState = {};

      if ('activeKey' in nextProps && nextProps.activeKey !== state.activeKey) {
        newState.activeKey = getActiveKey(nextProps);
      }

      if ('activeKey' in newState) {
        return newState;
      }

      return null;
    }
  }]);

  return Collapse;
}(Component);

Collapse.defaultProps = {
  prefixCls: 'za-collapse',
  multiple: false,
  animated: false,
  onChange: function onChange() {}
};
Collapse.Item = void 0;
export { Collapse as default };